import { render, staticRenderFns } from "./annex.vue?vue&type=template&id=6b11f79d&scoped=true&"
import script from "./annex.vue?vue&type=script&lang=js&"
export * from "./annex.vue?vue&type=script&lang=js&"
import style0 from "./annex.vue?vue&type=style&index=0&id=6b11f79d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b11f79d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b11f79d')) {
      api.createRecord('6b11f79d', component.options)
    } else {
      api.reload('6b11f79d', component.options)
    }
    module.hot.accept("./annex.vue?vue&type=template&id=6b11f79d&scoped=true&", function () {
      api.rerender('6b11f79d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/detail/components/annex.vue"
export default component.exports